require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-five-technologies-changing-agriculture-industry.json") })
        }
      }, "path---blog-five-technologies-changing-agriculture-industry");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-five-technologies-changing-agriculture-industry!./.cache/json/blog-five-technologies-changing-agriculture-industry.json
// module id = 805
// module chunks = 231608221292675